<template>
  <header>
    <nav class="container-nav">
      <div class="container-logo">
        <a
          href="https://joaoquinto.github.io/joaoquinto-portfolio/"
          class="logo"
          >Joãoquinto</a
        >
      </div>
      <button id="button-menu" @click="menuHamburguer">
        <span class="material-icons">{{
          buttonMenu === false ? "menu" : "menu_open"
        }}</span>
      </button>
      <ul
        :class="[{ visible: buttonMenu }, 'container-menu']"
        role="menu"
        :aria-expanded="arias.expanded"
        :aria-label="arias.orientation == 'vertical' ? 'Dropdown menu' : 'menu'"
        :aria-orientation="arias.orientation"
        :aria-hidden="arias.hidden"
      >
        <li
          class="menu-item"
          role="menuitem"
          v-for="({ id, title }, index) in anchor"
          :key="index"
        >
          <a :href="`#${id}`">{{ title }}</a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { ref, onMounted } from "vue";

const buttonMenu = ref(false);
const arias = ref({
  orientation: "",
  hidden: null,
  expanded: null,
});

export default {
  name: "HeaderVue",
  props: {
    anchor: {
      type: Object,
    },
  },
  setup() {
    const screenWidth = ref(document.body.clientWidth);

    function orientationAtributes() {
      if (screenWidth.value < 1140) {
        arias.value.orientation = "vertical";
        arias.value.expanded = false;
        arias.value.hidden = true;
      } else {
        arias.value.orientation = "horizontal";
        arias.value.expanded = true;
        arias.value.hidden = false;
      }
    }

    onMounted(() => {
      orientationAtributes();
    });

    return { buttonMenu, arias, screenWidth };
  },
  methods: {
    menuHamburguer() {
      buttonMenu.value = !buttonMenu.value;
      arias.value.expanded = !arias.value.expanded;
      arias.value.hidden = !arias.value.hidden;
    },
  },
};
</script>

<style scoped>
header {
  background-color: var(--bg-header);
  padding: 1.688rem 0;
  display: flex;
}

nav.container-nav {
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
}

a {
  color: var(--color-text);
  font-size: var(--fs-text-2);
  transition: color 0.3s;
}

a:hover {
  color: #707070;
}

nav > div.container-logo {
  align-self: flex-start;
}

button#button-menu {
  width: 54px;
  height: 35px;
  align-self: flex-end;
  position: relative;
  bottom: 27px;
  background-color: #707070;
  border: none;
  cursor: pointer;
}

a.logo {
  font-size: var(--fs-text-1);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 700;
}

ul.container-menu {
  display: none;
  visibility: hidden;
}

ul.container-menu.visible {
  display: flex;
  visibility: visible;
  flex-direction: column;
}

ul.container-menu {
  font-family: "Montserrat";
  text-transform: uppercase;
  font-weight: 200;
  text-align: center;
}

li + li {
  margin-top: 2.125rem;
}

@media (min-width: 1140px) {
  nav.container-nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
  }

  nav > div.container-logo {
    align-self: baseline;
  }

  button#button-menu {
    display: none;
    visibility: hidden;
  }

  ul.container-menu {
    display: flex;
    visibility: visible;
    flex-direction: row;
  }

  ul.container-menu.visible {
    flex-direction: row;
  }

  li + li {
    margin-top: 0;
    margin-left: 2.25rem;
  }
}
</style>
